import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BoloGrahakNearby from './BoloGrahakNearby';

const dummyProducts = [
  {
    id: 1,
    title: "Maldives Romantic Retreat",
    brief: "Save 50% on 5-star villas with ocean views.",
    type: "Hotel",
    location: "Maldives",
    hasVoucher: true,
    image: "/api/downloads/thinktravel/deals/1.png",
  },
  {
    id: 2,
    title: "Swiss Alps Escape",
    brief: "Ski & spa in the heart of Switzerland.",
    type: "Tour Operator",
    location: "Switzerland",
    hasVoucher: false,
    image: "/api/downloads/thinktravel/deals/2.png",
  },
];

const BoloGrahakCatalogue = () => {
  const [filters, setFilters] = useState({
    type: '',
    location: '',
    keywords: '',
    hasVoucher: false,
  });
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  const handleSearch = () => {
    // Simulate filter (use backend call in real app)
    const filtered = dummyProducts.filter(deal =>
      (!filters.type || deal.type === filters.type) &&
      (!filters.location || deal.location.toLowerCase().includes(filters.location.toLowerCase())) &&
      (!filters.hasVoucher || deal.hasVoucher)
    );
    setResults(filtered);
  };

const [nearbyClicked, setNearbyClicked] = useState(false);
const handleNearbyClicked = () => {
  setNearbyClicked(!nearbyClicked);
};

  return (
    <div className="w-full p-6 max-w-5xl mx-auto bg-gradient-to-r from-pink-500 via-blue-500 to-green-500">
      <h2 className="text-3xl font-bold mb-6 text-yellow-200">FeetFirst World</h2>

      {/* Filters */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <select 
          onChange={(e) => setFilters({ ...filters, type: e.target.value })}
          className="border p-2 rounded h-10"
        >
          <option value="">Select Type</option>
          <option value="Doctor">Doctor</option>
          <option value="Store">Store</option>
          <option value="Physioterapist">Physioterapist</option>
        </select>

        <input 
          type="text"
          placeholder="Location"
          onChange={(e) => setFilters({ ...filters, location: e.target.value })}
          className="border p-2 rounded"
        />

        <input 
          type="text"
          placeholder="Keywords"
          onChange={(e) => setFilters({ ...filters, keywords: e.target.value })}
          className="border p-2 rounded"
        />

        <label className="flex items-center space-x-2">
          <input 
            type="checkbox"
            onChange={(e) => setFilters({ ...filters, hasVoucher: e.target.checked })}
          />
          <span>Having Discount Voucher</span>
        </label>
      </div>
      <div className='flex flex-row justify-center'>
        <button 
          onClick={handleSearch}
          className="bg-pink-600 text-white px-6 py-2 w-40 mr-4 rounded-full hover:bg-pink-700 transition"
        >
          Search
        </button>

        <button 
          onClick={handleNearbyClicked}
          className="bg-pink-600 text-white w-40 px-6 py-2 rounded-full hover:bg-pink-700 transition"
        >
          FeetFirst Nearby
        </button>
      </div>
      {/* Results */}
      <div className="mt-8 space-y-4">
        {results.map(deal => (
          <div key={deal.id} className="bg-green-600 p-4 rounded shadow-md flex gap-4">
            <img src={deal.image} alt={deal.title} className="w-40 h-28 object-cover rounded" />
            <div>
              <h3 className="text-xl font-bold">{deal.title}</h3>
              <p className="text-white">{deal.brief}</p>
              <button 
                onClick={() => navigate(`/deal/${deal.id}`)}
                className="mt-2 bg-pink-400 text-white w-40 hover:bg-pink-700 transition"
              >
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>
      {nearbyClicked && (
        <FeetFirstNearby />
      )}
    </div>
  );
};

export default BoloGrahakCatalogue;
